<div *ngIf="shouldShowPreloader" class="preloader-backdrop">
  <div class="loader"></div>
</div>
